import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=3bdd078f"
import script from "./Statistics.vue?vue&type=script&lang=ts"
export * from "./Statistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_bef45e0e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bdd078f')) {
      api.createRecord('3bdd078f', component.options)
    } else {
      api.reload('3bdd078f', component.options)
    }
    module.hot.accept("./Statistics.vue?vue&type=template&id=3bdd078f", function () {
      api.rerender('3bdd078f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/admin/Statistics.vue"
export default component.exports